export default __webpack_public_path__ + "static/media/IMG_9908.5d510c2a.jpg";